export default class Helpers {
  /**
   * Change icon collapse when it toggles
   */
  static toggleCollapseIcon(target, openIcon, closeIcon) {
    target.addEventListener('show.bs.collapse', function () {
      openIcon.classList.add('d-none');
      closeIcon.classList.add('d-inline-block');
    });
    target.addEventListener('hide.bs.collapse', function () {
      openIcon.classList.remove('d-none');
      closeIcon.classList.remove('d-inline-block');
    });
  }
}